import { App } from 'vue'
import { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home/index.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register/index.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
  },
  {
    path: '/points',
    name: 'Points',
    component: () => import('@/views/Points/index.vue'),
  },
  {
    path: '/points-info',
    name: 'PointsInfo',
    component: () => import('@/views/Points/Records.vue'),
  },
  {
    path: '/invitation',
    name: 'Invitation',
    component: () => import('@/views/Invitation/index.vue'),
  },
  {
    path: '/invitation-rules',
    name: 'InvitationRules',
    component: () => import('@/views/Invitation/rules.vue'),
  },
  {
    path: '/invitation-records',
    name: 'InvitationRecords',
    component: () => import('@/views/Invitation/records.vue'),
  },
  {
    path: '/rebate',
    name: 'Rebate',
    component: () => import('@/views/Rebate/index.vue'),
  },
  {
    path: '/rebate-records',
    name: 'RebateRecords',
    component: () => import('@/views/Rebate/records.vue'),
  },
  {
    path: '/user-agreement',
    name: 'userAgreement',
    component: () => import('@/views/UsersAgreement/index.vue'),
  },
  {
    path: '/account-cancellation',
    name: 'accountCancellation',
    component: () => import('@/views/AccountCancellation/index.vue'),
  },
  {
    path: '/dex',
    name: 'dex',
    redirect: '/dex/trade',
    component: () => import('@/views/Dex/index.vue'),
    children: [
      {
        path: 'markets',
        name: 'markets',
        component: () => import('@/views/Dex/children/Markets.vue'),
      },
      {
        path: 'trade/:address?',
        name: 'trade',
        component: () => import('@/views/Dex/children/Trade.vue'),
      },
      {
        path: 'wallet',
        name: 'wallet',
        component: () => import('@/views/Dex/children/Wallet.vue'),
      },
    ],
  },
  {
    path: '/market/:address?',
    name: 'market',
    component: () => import('@/views/Dex/Market.vue'),
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/Dex/Search.vue'),
  },

  {
    path: '/assets',
    name: 'assets',
    component: () => import('@/views/Dex/Assets.vue'),
  },
  {
    path: '/order-history',
    name: 'orderHistory',
    component: () => import('@/views/Dex/OrderHistory.vue'),
  },
  {
    path: '/order-details',
    name: 'orderDetails',
    component: () => import('@/views/Dex/OrderDetails.vue'),
  },
  {
    path: '/withdrawal/:symbol',
    name: 'withdrawal',
    component: () => import('@/views/Dex/Withdrawal.vue'),
  },
  {
    path: '/withdrawal-history',
    name: 'withdrawalHistory',
    component: () => import('@/views/Dex/WithdrawalHistory.vue'),
  },
  {
    path: '/withdrawal-detail',
    name: 'withdrawalDetail',
    component: () => import('@/views/Dex/WithdrawalDetail.vue'),
  },
  {
    path: '/chains',
    name: 'chains',
    component: () => import('@/views/Dex/Chains.vue'),
  },
  {
    path: '/deposit/:chain',
    name: 'deposit',
    component: () => import('@/views/Dex/Deposit.vue'),
  },
  {
    path: '/order-confirm',
    name: 'orderConfirm',
    component: () => import('@/views/Dex/OrderConfirm.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('@/views/Unsubscribe/index.vue'),
  },
  {
    path: '/user-center',
    name: 'userCenter',
    component: () => import('@/views/UserCenter/index.vue'),
  },
  {
    path: '/:inviter',
    component: () => { },
    beforeEnter: (to, from, next) => {
      const inviter = to.params.inviter as string
      if (inviter && inviter.startsWith('@')) {
        next({
          name: 'Register',
          query: { ...to.query, inviteCode: inviter.slice(1) },
          replace: true,
        })
      } else {
        next()
      }
    }
  }
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const accessToken = from.query?.accessToken
  if (accessToken && to.query.accessToken !== accessToken) {
    to.query.accessToken = accessToken
    next({
      ...to,
      query: {
        ...to.query,
        accessToken,
      },
    })
  } else {
    next()
  }
})

export async function setupRouter(app: App) {
  app.use(router)
  await router.isReady()
}
